export default __webpack_public_path__ + "static/media/Kitchen_tools.ae3fd8b0.jpg";